export default __webpack_public_path__ + "static/media/sazu.ef7a59bb.jpg";